"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _usePopover = require("./usePopover.styles");

var _PopoverComponent = _interopRequireDefault(require("./PopoverComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @typedef popoverOptions
 * @property {{ 'open' | 'closed' }} initialState - whether the PopOver should start open or closed.
 */

/**
 * @typedef Popover
 * @property {{ 'top' | 'right' | 'bottom' | 'left'}} position - The absolute position of the popover
 *  as relates to its parent element.
 * @property {{'start' | 'end'}} align - Whether to align the popover at the start or end of its parent.
 * @property {number} arrowSize - the size of the popover Arrow. Defaults to 8. Currently a bit wonky.
 */

/**
 * @typedef hookReturn
 * @property {ref} anchorRef - A ref to attach to the desired anchor element. Used to place Popover
 * @property {Popover} Popover - the Popover element that will wrap your Children.
 * @property {node} PopoverAnchorWrapper - An optional helper Wrapper to position the Popover.
 * @property {boolean} isOpen - Whether the Popover is currently open.
 * @property {function} toggle - Imperatively toggles the popover
 * @property {function} close - Imperatively closes the popover
 * @property {object} popoverProps - a helper object for destructring into Popover Component
 * @property {boolean} popoverProps.isOpen - Whether the Popover is currently open.
 * @property {function} popoverProps.close - Imperatively closes the popover
 * @property {ref} popoverProps.anchorRef - A ref to attach to the desired anchor element. Used to place Popover
 */

/**
 * The usePopover hook makes a popover/tool-tip like experience with which users can interact.
 * It returns a `<Popover>` used to wrap whichever elem you you want to anchor the Popover onto.
 * It also exposes imperative handlers and an isOpen boolean.
 * 
 * The tricky piece of this is that you need to destructure popoverProps into <Popover/>.
 * This is so that way the instantiated Popover component know about and react to the hook's state.
 * 
 * @param {popoverOptions} options - The popover's initial State.
 * @returns {}
 */
var usePopover = function usePopover() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialState = options.initialState;
  var anchorRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(initialState === 'open'),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var toggle = (0, _react.useCallback)(function () {
    return setOpen(function (prev) {
      return !prev;
    });
  }, []);
  var close = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, []);
  var popoverProps = {
    isOpen: isOpen,
    close: close,
    anchorRef: anchorRef
  };
  return {
    isOpen: isOpen,
    popoverProps: popoverProps,
    PopoverAnchorWrapper: _usePopover.PopoverAnchorWrapper,
    Popover: _PopoverComponent["default"],
    toggle: toggle,
    close: close,
    anchorRef: anchorRef
  };
};

usePopover.propTypes = {
  options: _propTypes["default"].shape({
    initialState: _propTypes["default"].bool
  })
};
var _default = usePopover;
exports["default"] = _default;